import {
  FaTicketAlt,
  FaPlusCircle,
  FaQuestionCircle,
  FaBook,
  FaBug,
  FaVideo,
} from "react-icons/fa";
import {
  FaMessage,
  FaHeadset,
  FaRobot,
  FaArrowLeft,
  FaClock,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import TicketService from "../../../../services/Ticket";
import { useEffect, useState } from "react";
import fixDate from "../../../../components/DateFormatter/FixDate";
import CreateTicketModal from "./CreateTicketModal";

export default function Support() {
  const navigate = useNavigate();
  const [myTickets, setMyTickets] = useState([]);
  const [isTicketsOpen, setIsTicketsOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
    const getMyTickets = async () => {
      try {
        const response = await TicketService.getMyTickets();
        setMyTickets(response?.data?.message);
        console.log("My tickets:", response.data);
      } catch (error) {
        console.error("Error fetching tickets:", error);
      }
    };
  useEffect(() => {

    getMyTickets();
  }, []);

  return (
    <div dir="ltr">
      <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4 flex items-center justify-between border-b border-gray-100">
        <button
          onClick={() => navigate("/profile")}
          className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
        >
          <FaArrowLeft className="text-gray-600" />
        </button>
        <div className="text-center">
          <h1 className="text-lg font-bold text-gray-900">Support</h1>
          <p className="text-xs text-gray-500">Online</p>
        </div>
        <div className="w-10"></div>
      </header>

      <div className="bg-gray-50 pb-20 mt-16">
        <section id="support-options" className="px-4 py-6">
          <div className="grid grid-cols-1 gap-4">
            {/* <div className="bg-white rounded-2xl p-5 shadow-lg border border-gray-50 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-20 h-20 bg-gradient-to-br from-primary/20 to-transparent rounded-br-full"></div>
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-primary to-purple-600 rounded-xl flex items-center justify-center shadow-md flex-shrink-0">
                    <FaRobot className="text-white text-lg" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-base">
                      Smart Support Bot
                    </h3>
                    <p className="text-xs text-gray-500 mt-1">
                      Instant 24/7 responses
                    </p>
                  </div>
                </div>
                <div className="flex items-center bg-green-50 px-2 py-1 rounded-full flex-shrink-0 gap-2">
                  <span className="text-xs text-green-600 font-medium">
                    Active
                  </span>
                  <div className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1"></div>
                </div>
              </div>
              <button
                id="chat-bot-btn"
                className="w-full bg-gradient-to-r from-primary to-purple-600 text-white py-3 rounded-xl font-medium flex items-center justify-center gap-2 hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
              >
                <FaMessage />
                <span>Start Chat</span>
              </button>
            </div> */}

            {/* <div className="bg-white rounded-2xl p-5 shadow-lg border border-gray-50 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-20 h-20 bg-gradient-to-br from-emerald-400/20 to-transparent rounded-br-full"></div>
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-emerald-500 to-green-600 rounded-xl flex items-center justify-center shadow-md flex-shrink-0">
                    <FaHeadset className="text-white text-lg" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-base">
                      Live Support
                    </h3>
                    <p className="text-xs text-gray-500 mt-1">
                      Expert human support
                    </p>
                  </div>
                </div>
                <div className="flex items-center bg-amber-50 px-2 py-1 rounded-full flex-shrink-0 gap-2">
                  <span className="text-xs text-amber-600 font-medium">
                    2 min
                  </span>
                  <div className="w-1.5 h-1.5 bg-amber-500 rounded-full mr-1 animate-pulse"></div>
                </div>
              </div>
              <button
                id="live-support-btn"
                className="w-full bg-gradient-to-r from-emerald-500 to-green-600 text-white py-3 rounded-xl font-medium flex items-center justify-center gap-2 hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
              >
                <FaHeadset />
                <span>Connect to Support</span>
              </button>
            </div> */}

            <div className="bg-white rounded-2xl p-5 shadow-lg border border-gray-50 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-20 h-20 bg-gradient-to-br from-orange-400/20 to-transparent rounded-br-full"></div>
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-xl flex items-center justify-center shadow-md flex-shrink-0">
                    <FaTicketAlt className="text-white text-lg" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-base">
                      Support Ticket
                    </h3>
                    <p className="text-xs text-gray-500 mt-1">
                      Detailed issue reporting
                    </p>
                  </div>
                </div>
                <div className="flex items-center bg-blue-50 px-2 py-1 rounded-full flex-shrink-0 gap-2">
                  <span className="text-xs text-blue-600 font-medium">
                    24 hours
                  </span>
                  <FaClock className="text-blue-600 text-xs mr-1" />
                </div>
              </div>
              <button
                id="create-ticket-btn"
                className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-xl font-medium flex items-center justify-center gap-2 hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
                onClick={() => setIsModalOpen(true)}
              >
                <FaPlusCircle />
                <span>Create New Ticket</span>
              </button>
            </div>
          </div>

          <div className="mt-6 bg-gradient-to-r from-gray-50 to-blue-50/30 rounded-2xl p-4">
            <div className="flex justify-around">
              <div className="text-center flex-1">
                <div className="text-lg font-bold text-gray-900">98%</div>
                <div className="text-xs text-gray-500 mt-1">Satisfaction</div>
              </div>
              <div className="w-px h-8 bg-gray-200"></div>
              <div className="text-center flex-1">
                <div className="text-lg font-bold text-gray-900">
                  &lt; 5 min
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  Average Response
                </div>
              </div>
              <div className="w-px h-8 bg-gray-200"></div>
              <div className="text-center flex-1">
                <div className="text-lg font-bold text-gray-900">24/7</div>
                <div className="text-xs text-gray-500 mt-1">Available</div>
              </div>
            </div>
          </div>
        </section>

        {/* <section id="quick-actions" className="px-4">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Quick Access</h2>
          <div className="grid grid-cols-2 gap-4 mb-6">
            <button className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mx-auto mb-3">
                <FaQuestionCircle className="text-blue-600 text-lg" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-1">FAQ</h3>
              <p className="text-xs text-gray-500">Common questions</p>
            </button>

            <button className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center mx-auto mb-3">
                <FaBook className="text-purple-600 text-lg" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-1">
                User Guide
              </h3>
              <p className="text-xs text-gray-500">Usage tutorial</p>
            </button>

            <button className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center mx-auto mb-3">
                <FaVideo className="text-green-600 text-lg" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-1">
                Video Tutorials
              </h3>
              <p className="text-xs text-gray-500">Instructional videos</p>
            </button>

            <button className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all">
              <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center mx-auto mb-3">
                <FaBug className="text-red-600 text-lg" />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm mb-1">
                Report an Issue
              </h3>
              <p className="text-xs text-gray-500">Log a bug or error</p>
            </button>
          </div>
        </section> */}

        <section className="px-4 mb-5">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-gray-900">Recent Tickets</h2>

            {myTickets.length > 0 && (
              <button
                onClick={() => setIsTicketsOpen((prev) => !prev)}
                className="text-primary text-sm font-medium"
              >
                {isTicketsOpen ? "Show All" : "Show Less"}
              </button>
            )}
          </div>

          <div
            className={`space-y-3 max-h-[350px] rounded-lg ${
              isTicketsOpen
                ? "overflow-y-hidden"
                : "overflow-y-auto p-1 bg-gray-100"
            }`}
          >
            {myTickets.length > 0 ? (
              myTickets
                .slice(0, isTicketsOpen ? 3 : myTickets.length)
                .map((ticket) => (
                  <div
                    key={ticket?._id}
                    className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm cursor-pointer hover:shadow-md transition-shadow"
                    onClick={() => navigate(`/support/${ticket?._id}`)}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        <div className="w-3 h-3 bg-green-500 rounded-full ml-3"></div>

                        <span className="font-semibold text-gray-900 text-sm">
                          {ticket?.subject}
                        </span>
                      </div>

                      <span
                        className={`${
                          ticket?.close
                            ? "bg-red-100 text-red-700"
                            : "bg-green-100 text-green-700"
                        } px-2 py-1 rounded-lg text-xs font-medium`}
                      >
                        {ticket?.close ? "Closed" : "Open"}
                      </span>
                    </div>

                    <p className="text-xs text-gray-500 mb-2">
                      Ticket #{ticket?._id}
                    </p>

                    <p className="text-xs text-gray-400">
                      {fixDate(ticket?.createdAt) || "-"}
                    </p>
                  </div>
                ))
            ) : (
              <div className="bg-white rounded-2xl p-6 text-center border border-gray-100">
                <FaTicketAlt className="text-gray-400 text-3xl mx-auto mb-3" />

                <p className="text-sm text-gray-500">
                  You don't have any tickets yet.
                </p>
              </div>
            )}
          </div>
        </section>
      </div>
      <CreateTicketModal
  isOpen={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  onCreated={getMyTickets}
/>
    </div>
  );
}
